// extracted by mini-css-extract-plugin
module.exports = {"footerContent":"Footer-module--footerContent--2pR8u"};